module.exports = __webpack_public_path__ + "img/61.7b8c96c1.svg";